import React, { ChangeEvent, FC, useEffect, useMemo, useState } from "react";

import "./dateInput.scss";
import { useSelector } from "react-redux";
import { ReducerState } from "AppTypes";
import {
  getMonthOptions,
  dayOptions,
  getYearOptions,
} from "../../utils/dateOptions";
import { isValid } from "date-fns";
import { SingleTimeSelect } from "./SingleTimeSelect";

interface DateSelectValues {
  date: any;
  month: any;
  year: any;
}

const defaultDate = {
  date: '',
  month: '',
  year: ''
}
interface Props {
  disabled: boolean, handleSubmit: (values: DateSelectValues) => void
}

export const DesktopDateOfBirthSelect: FC<Props> = ({ handleSubmit, disabled }) => {
  const [values, setValues] = useState<DateSelectValues>(defaultDate);

  const { lang, langPack } = useSelector((store: ReducerState) => ({
    lang: store.config.lang,
    langPack: store.config.langPack,
  }));
  const monthOptions = useMemo(() => getMonthOptions(lang), [lang]);

  const onChangeHander = (
    e: ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    const { name, value } = e.target;
    const newValue = {
      ...values,
      [name]: value,
    };

    if ((newValue.month || newValue.month === 0) && newValue.year) {
      const maxDate = new Date(newValue.year, newValue.month + 1, 0).getDate();
      if (maxDate < newValue.date) {
        newValue.date = maxDate;
      }
    }

    setValues(newValue);
  };

  useEffect(() => {
    const { date, month, year } = values;
    if (date && year && (month || month === 0)) {
      const newDate = new Date(year, month, date);
      if (isValid(newDate)) {
        handleSubmit(values)
        setValues(defaultDate)
      }
    }
  }, [values]);

  return (
    <div className="custom-desktop-datepicker">
      <div className="custom-desktop-datepicker__inputs">
        <SingleTimeSelect
          name="date"
          label={langPack.labelDate}
          onChange={onChangeHander}
          value={values.date}
          options={dayOptions}
          disabled={disabled}
        />
        <SingleTimeSelect
          name="month"
          label={langPack.labelMonth}
          onChange={onChangeHander}
          value={values.month}
          options={monthOptions}
          disabled={disabled}
        />
        <SingleTimeSelect
          name="year"
          label={langPack.labelYear}
          onChange={onChangeHander}
          value={values.year}
          options={getYearOptions}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
